function sendDataToNewrelic(stage: string, error_msg: string) {
  const params = `?serviceApp=aerial&stage=${stage}&vertical=flight&flavour=mobile&error_msg=${error_msg}`;
  try {
    const url = `https://dexter.goibibo.com/common/newrelic/${params}`;
    // console.log('dexter newrelic sendDataToNewrelic: url: ', url);
    // fetch(url);
  } catch (e) {
    // console.log('Failed to push data to new relic. ERROR = ', e);
  }
}

export default sendDataToNewrelic;
